import React from "react";
import { Grid, Typography } from "@mui/material";
import Absences from "src/features/attendance/components/Absences";
import { ViewBase } from "src/app/components/ViewBase";

const MissingsView = () => {
  return (
    <ViewBase>
      <Typography variant="h2" sx={{ mb: 4, mt: 2 }}>
        העדרויות
      </Typography>
      <Grid item xs={12}>
        <Absences />
      </Grid>
    </ViewBase>
  );
};

export default MissingsView;
